module.exports = __webpack_public_path__ + "img/drooling_face.a52797cd.gif";